import type { FiltruRaport, FiltruRapidDef } from "@/utils/targetareRaport";
import { SURSE_CONTACT } from "@/utils/targetareSurse";
import {
  ETICHETE_ACTIONARIAT,
  ETICHETE_DIMENSIUNE,
  ETICHETE_INCADRARE,
  ETICHETE_NIVEL_RISC,
  ETICHETE_ORIGINE,
  ETICHETE_TIER,
} from "@/utils/targetareTabel";

export type { FiltruRapidDef } from "@/utils/targetareRaport";

export const FILTRE_RAPIDE_FIRME: FiltruRapidDef[] = [
  {
    coloana: "dimensiune_stricta",
    eticheta: "Dimensiune",
    optiuni: ["mare", "mijlocie", "mica", "micro"],
    etichete: ETICHETE_DIMENSIUNE,
  },
  {
    coloana: "clasificare_estimata",
    eticheta: "Încadrare",
    optiuni: ["ESSENTIAL", "IMPORTANT", "OUT_OF_SCOPE"],
    etichete: ETICHETE_INCADRARE,
  },
  {
    coloana: "tier",
    eticheta: "Nivel de încadrare",
    optiuni: ["A", "B", "C", "D"],
    etichete: ETICHETE_TIER,
  },
  {
    coloana: "nivel_risc",
    eticheta: "Nivel de risc",
    optiuni: ["esential", "important", "de_baza"],
    etichete: ETICHETE_NIVEL_RISC,
  },
  { coloana: "sectoare", eticheta: "Sector" },
  {
    coloana: "actionariat",
    eticheta: "Acționariat",
    optiuni: ["privat", "mixt", "stat_central", "stat_local", "regie_autonoma"],
    etichete: ETICHETE_ACTIONARIAT,
  },
  {
    coloana: "surse",
    eticheta: "Sursă de date",
    optiuni: SURSE_CONTACT,
  },
  {
    coloana: "origine",
    eticheta: "Origine",
    optiuni: ["clasificare", "nis2pass"],
    etichete: ETICHETE_ORIGINE,
  },
];

export const FILTRE_RAPIDE = FILTRE_RAPIDE_FIRME;

const PREFIX_FILTRU_RAPID = "rapid:";

export const idFiltruRapid = (coloana: string): string =>
  `${PREFIX_FILTRU_RAPID}${coloana}`;

export function valoriFiltruRapid(
  filtre: FiltruRaport[],
  coloana: string
): string[] {
  const f = filtre.find((x) => x.id === idFiltruRapid(coloana));
  return f?.activ ? (f.valori ?? []) : [];
}

export function seteazaFiltruRapid(
  filtre: FiltruRaport[],
  coloana: string,
  valori: string[]
): FiltruRaport[] {
  const id = idFiltruRapid(coloana);
  if (valori.length === 0) return filtre.filter((f) => f.id !== id);
  const nou: FiltruRaport = {
    id,
    coloana,
    operator: "in",
    valori,
    activ: true,
  };
  return filtre.some((f) => f.id === id)
    ? filtre.map((f) => (f.id === id ? nou : f))
    : [...filtre, nou];
}

export function comutaValoareFiltruRapid(
  filtre: FiltruRaport[],
  coloana: string,
  valoare: string
): FiltruRaport[] {
  const curente = valoriFiltruRapid(filtre, coloana);
  const urmatoare = curente.includes(valoare)
    ? curente.filter((v) => v !== valoare)
    : [...curente, valoare];
  return seteazaFiltruRapid(filtre, coloana, urmatoare);
}

export function stergeFiltreleRapide(filtre: FiltruRaport[]): FiltruRaport[] {
  return filtre.filter((f) => !f.id.startsWith(PREFIX_FILTRU_RAPID));
}

export function etichetaValoareRapida(
  def: FiltruRapidDef,
  valoare: string
): string {
  return def.etichete?.[valoare] ?? valoare;
}
